module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-option', {
    attrs: {
      "title": _vm.label,
      "label": _vm._f("titleLimit")(_vm.label),
      "value": _vm.value
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-39989229!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/global/limitOption.vue
// module id = 726
// module chunks = 1